import router from '../../router/index';
const cipher = function (salt, text) {
  const textToChars = (text) => text.split('').map((c) => c.charCodeAt(0));
  const byteHex = (n) => ('0' + Number(n).toString(16)).substr(-2);
  const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);

  return text.split('').map(textToChars).map(applySaltToChar).map(byteHex).join('');
};

// const decipher = function (salt, encoded) {
//   const textToChars = (text) => text.split('').map((c) => c.charCodeAt(0));
//   const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);
//   return encoded
//     .match(/.{1,2}/g)
//     .map((hex) => parseInt(hex, 16))
//     .map(applySaltToChar)
//     .map((charCode) => String.fromCharCode(charCode))
//     .join('');
// };

const state = {
  user: {
    Id: '',
    isAuth: false,
    Email: '',
    FirstName: '',
    LastName: '',
    Mobile: '',
    Manager: {
      Id: '',
      Email: '',
      FirstName: '',
      LastName: '',
      Mobile: ''
    }
  },
  token: ''
};
const getters = {
  isAuth: (state) => state.user.isAuth && state.token,
  userInfo: (state) => state.user,
  managerInfo: (state) => state.user.Manager,
  getPassword: (state) => state.token
};
const mutations = {
  logIn: (state, data) => {
    state.user.isAuth = true;
    state.user.Id = data.Id;
    state.user.Email = data.Email;
    state.token = cipher(process.env.NODE_ENV, data.Password);
    state.user.FirstName = data?.FirstName ?? '';
    state.user.LastName = data?.LastName ?? '';
    state.user.Mobile = data?.Mobile ?? '';

    // ISO Manager
    state.user.Manager = {
      Id: data?.Manager?.Id ?? '',
      Email: data?.Manager?.Email ?? '',
      FirstName: data?.Manager?.FirstName ?? '',
      LastName: data?.Manager?.LastName ?? '',
      Mobile: data?.Manager?.Mobile ?? ''
    };

    router.push('/submissions');
  },
  updateUser: (state, data) => {
    state.user.Id = data.Id;
    state.user.Email = data.Email;
    state.user.FirstName = data?.FirstName ?? '';
    state.user.LastName = data?.LastName ?? '';
    state.user.Mobile = data?.Mobile ?? '';

    // ISO Manager
    state.user.Manager = {
      Id: data?.Manager?.Id ?? '',
      Email: data?.Manager?.Email ?? '',
      FirstName: data?.Manager?.FirstName ?? '',
      LastName: data?.Manager?.LastName ?? '',
      Mobile: data?.Manager?.Mobile ?? ''
    };
  },
  logOut: (state) => {
    state.user = {
      Id: '',
      isAuth: false,
      Email: '',
      FirstName: '',
      LastName: '',
      Mobile: '',
      Manager: {
        Id: '',
        Email: '',
        FirstName: '',
        LastName: '',
        Mobile: ''
      }
    };
    state.token = '';
    router.push('/login');
  },
  updatePassword: (state, data) => {
    state.token = cipher(process.env.NODE_ENV, data);
  }
};
const actions = {
  async logInUser({ commit }, data) {
    commit('logIn', data);
  },
  async updateUserInfo({ commit }, data) {
    commit('updateUser', data);
  },
  async logOutUser(context) {
    context.commit('logOut');
  },
  async updatePassword({ commit }, data) {
    commit('updatePassword', data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
